import type { Maybe } from '@adornis/base/utilTypes.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { textToSpeech } from '@adornis/speech/client/text-to-speech.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @customElement campus-component-text-to-speech-button
 */
@customElement('campus-component-text-to-speech-button')
export class CampusComponentTextToSpeechButton extends ChemistryLitElement {
  @property({ attribute: false }) public text: Maybe<number | string>;

  override render() {
    return html`
      <cr-button
        mode="fab"
        icon="volume_up"
        @click=${() => {
          void textToSpeech(this.text?.toString() ?? '');
        }}
      >
        <slot></slot>
      </cr-button>
    `;
  }
}
